import { markdownParser } from '@u/markdown-parser'
import React from 'react'

export interface IPlatinumRichTextProps {
  name: string
  jsonBody: {
    markupText: string
  }
  variant: string
  rawName: string
  sys: { id: string }
}

const PlatinumRichText = (markupText: string, containerName: string = '') => {
  const parsed = markdownParser(markupText, containerName)
  return <div className='platinum-rich-text' dangerouslySetInnerHTML={{ __html: parsed }}></div>
}
export default PlatinumRichText
